import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../components/Icon";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { Button, Field } from "../components/ui";
import { useAuth } from "../auth";
import { useI18n } from "../i18n";
import { C, S } from "../theme";

export default function Login() {
  const { login } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [identifier, setId] = useState("");
  const [password, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async () => {
    setErr(""); setBusy(true);
    try {
      await login(identifier, password);
      nav("/");
    } catch (e) {
      setErr(e?.message || t("auth.loginFailed"));
    } finally { setBusy(false); }
  };

  return (
    <div className="screen fade-up" style={{ padding: 24, paddingTop: 48 }}>
      <div style={{ width: 84, height: 84, borderRadius: 20, background: C.amber, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Icon name="shield-checkmark" size={44} color={C.black} />
      </div>
      <h1 className="display" style={{ color: C.text, fontSize: 40, fontWeight: 900, marginTop: 16, marginBottom: 0, letterSpacing: 1 }}>SafeBook</h1>
      <div style={{ color: C.muted, fontSize: 16, marginTop: 4, marginBottom: 24 }}>{t("auth.tagline")}</div>

      <Field label={t("auth.identifier")} testID="login-identifier" autoCapitalize="none" value={identifier} onChange={(e) => setId(e.target.value)} placeholder={t("auth.emailPlaceholder")} />
      <Field label={t("auth.passwordPin")} testID="login-password" type="password" value={password} onChange={(e) => setPw(e.target.value)} placeholder="••••••" onKeyDown={(e) => e.key === "Enter" && submit()} />
      {!!err && <div data-testid="login-error" style={{ color: C.red, marginBottom: 12, fontWeight: 600 }}>{err}</div>}
      <Button title={t("auth.signIn")} testID="login-submit" onPress={submit} loading={busy} />
      <button data-testid="go-forgot" className="pressable" onClick={() => nav("/forgot-password")} style={{ display: "block", margin: "12px auto 0", color: C.sub, fontWeight: 600, fontSize: 14 }}>{t("auth.forgotPassword")}</button>
      <button data-testid="go-register" className="pressable" onClick={() => nav("/register")} style={{ display: "block", margin: "12px auto 0", color: C.amber, fontWeight: 700, fontSize: 15 }}>{t("auth.newOwner")}</button>
      <div data-testid="login-language-switcher" style={{ display: "flex", justifyContent: "center", marginTop: 28 }}>
        <LanguageSwitcher align="center" />
      </div>
    </div>
  );
}
